var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdvisors = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 11C9.32608 11 10.5979 10.4732 11.5355 9.53553C12.4732 8.59785 13 7.32608 13 6C13 4.67392 12.4732 3.40215 11.5355 2.46447C10.5979 1.52678 9.32608 1 8 1C6.67392 1 5.40215 1.52678 4.46447 2.46447C3.52678 3.40215 3 4.67392 3 6C3 7.32608 3.52678 8.59785 4.46447 9.53553C5.40215 10.4732 6.67392 11 8 11ZM8 11C10.013 11 11.772 11.76 13.023 13.023C13.7647 13.775 14.3196 14.6905 14.643 15.696M8 11C4 11 1 14 1 18V23H11M12 18.824L16.19 22L23 13",
  stroke: "currentColor",
  strokeWidth: 2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdvisors);
export { ForwardRef as ReactComponent };